
import { mapActions, mapMutations, mapState } from "vuex";

export default {
    props: ["room", "source"],
    data (){
        return {
            isFinishCalculated: false,

            message: null,
            messageLimit: 150,
            isOpenEmojiContainer: false,
            isOpenStickerContainer: false,
            isAllowSendLiveChat: true,
            isAllowSendSticker: true,
            blockMessageTimer: 3000,

            stickers: 5,
            emojiList: ["😀","😃","😄","😁","😆","😅","🤣","😂","🙂","🙃","😉","😊","😇","😍","🤩","😘","😗","😚","😙","😋","😛","😜","🤪","😝","🤑","🤗","🤭","🤫","🤔","🤐","🤨","😐","😑","😶","😏","😬","🤥","😌","😔","😪","🤤","😴","😷","😵","🤯","🤠","😎","🤓","🧐","😟","🙁","😮","😯","😲","😳","😦","😧","😨","😰","😥","😢","😭","😱","🤡","👹","👻","👽","👾","🤖","😺","😸","😹","😻","😼","😽","🙀","😿","😾","🙈","🙉","🙊","💋","💌","💘","💝","💖","💗","💓","💞","💕","💟","🧡","💛","💚","💙","💜","🖤","💯","💫","💦","💨","💣","💬","💭","💤","👋","🤚","🖐","✋","🖖","👌","🤞","🤟","🤘","🤙","👈","👉","👆","👇","👍","✊","👊","🤛","🤜","👏","🙌","👐","🤲","🤝","🙏"],
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            moderators: state => state.live_chat.moderators,
            liveChatItems: state => state.live_chat.items,
            pinMessageItem: state => state.live_chat.pin_item,
            isNewMessageItem: state => state.live_chat.is_new_item,
            isBottomLiveChat: state => state.live_chat.is_bottom,
        }),
        isModerator(){
            return this.moderators.includes(this.user.id);
        }
    },
    mounted(){
        this.setMyRoom(this.room);

        // messageLimit = 0 = infinity
        // this.$socket.emit("initialLiveChat", "room", "messageLimit", "get_moderator", "get_pin");
        this.$socket.emit("initialLiveChat", this.room, 0, true, true);

        $("#live_chat_content").scroll(() => {
            if($("#live_chat_content").scrollTop() + $("#live_chat_content").height() >= $("#live_chat_detail").height() - 16) {
                this.$store.commit("live_chat/setIsBottom", true );
            }else{
                this.$store.commit("live_chat/setIsBottom", false );
            }
        })
    },
    methods: {
        ...mapMutations({
            setMyRoom: "live_chat/setMyRoom",
        }),
        onToggleEmojiContainer(){
            if(this.isOpenStickerContainer){
                this.isOpenStickerContainer = false;
            }

            this.isOpenEmojiContainer = !this.isOpenEmojiContainer;
        },
        onToggleStickerContainer(){
            if(this.isOpenEmojiContainer){
                this.isOpenEmojiContainer = false;
            }

            this.isOpenStickerContainer = !this.isOpenStickerContainer;
        },
        addEmojiToText(item){
            var chatInput = $("#chat_field")[0];
            if(!this.isAllowSendLiveChat || (!this.isModerator && $("#chat_field").val().length >= this.messageLimit - 1)) return chatInput.focus();

            var startPos = chatInput.selectionStart,
                endPos = chatInput.selectionEnd,
                cursorPos = startPos,
                tmpStr = chatInput.value;

            this.message = tmpStr.substring(0, startPos) + item + tmpStr.substring(endPos, tmpStr.length);
            setTimeout(() => {
                cursorPos += item.length;
                chatInput.focus();
                chatInput.selectionStart = chatInput.selectionEnd = cursorPos;
            }, 10);
        },
        onTypingMessage(event){
            event = (event)? event : window.event;
            if(!this.isModerator && $("#chat_field").val().length >= this.messageLimit) return event.preventDefault();
        },
        clickSendLiveChatButton(){
            this.message = this.sanitizeText(this.message);
            if(!this.message || !this.isAllowSendLiveChat) return;
            
            if(!this.isModerator){
                this.isAllowSendLiveChat = false;
                setTimeout(() => {
                    this.isAllowSendLiveChat = true;
                }, this.blockMessageTimer);
            }

            this.$socket.emit("sendLiveChatMessage", {
                room: this.room,
                message: this.isModerator? this.message : this.message.substring(0, this.messageLimit),
                // message: this.sanitizeText(this.isModerator? sanitizeMessage : this.message.substring(0, this.messageLimit)),
                avatar_url: this.user.avatar_url
            });

            this.message = "";
            this.isOpenEmojiContainer = false;
            if(this.room != "test_room"){
                this.$store.dispatch('auth/onTriggerAnalytics', { action: `send@message@${ this.room }`, event: "click_event", route: this.$route.path });
            }
        },
        clickSendStickerButton(item){
            if(!item || !this.isAllowSendSticker) return;

            if(!this.isModerator){
                this.isAllowSendSticker = false;
                setTimeout(() => {
                    this.isAllowSendSticker = true;
                }, this.blockMessageTimer);
            }

            this.$socket.emit("sendLiveChatMessage", {
                room: this.room,
                message: `${ process.env.domainUrl }/static/images/auditorium/stickers/${ item }.png`
            });

            this.isOpenStickerContainer = false;
            if(this.room != "test_room"){
                this.$store.dispatch('auth/onTriggerAnalytics', { action: `send@sticker@${ this.room }`, event: "click_event", route: this.$route.path });
            }
        },
        async pinMessage(hid){
            if(this.isModerator){
                const res = await this.showConfirmSwal("This message will pin on live chat!", "Yes, Pin it!");
                if (res.value) this.$socket.emit("pinMessage", this.room, hid);
            }
        },
        removePinMessage(){
            if(this.isModerator){
                this.$socket.emit("unpinMessage", this.room);
            }
        },
        onClickScrollBottomBtn(){
            this.$store.commit("live_chat/setIsBottom", true );
            this.$store.dispatch('live_chat/scroll', true);
        }
    },
    watch: {

    }
}
